// extracted by mini-css-extract-plugin
export var button = "_dz-7";
export var buttonRow = "_dz-6";
export var fadeIn = "_dz-1";
export var gradient = "_dz-0";
export var panel = "_dz-2";
export var panelIn = "_dz-3";
export var subtitle = "_dz-5";
export var title = "_dz-4";